// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Nben","newExpiryDate":"styles_newExpiryDate__1o36G","footer":"styles_footer__15UOk"};